export const BDXManagementTableFiltersFCPStatusOptions = [
  { text: 'All', value: 'All' },
  { text: 'FCP', value: 'Active' },
  { text: 'Non-FCP', value: 'Inactive' }
]

export const BDXManagementTableFiltersRECStatusOptions = [
  { text: 'ALL', value: 'All' },
  { text: 'REC', value: 'Active' },
  { text: 'NON-REC', value: 'Inactive' }
]

export const BDXManagementTableFiltersClaimStatusOptions = [
  { text: 'All', value: 'All' },
  { text: 'Open', value: 'True' },
  { text: 'Closed', value: 'False' }
]

export const BDXManagementTableFiltersBooleanOptions = [
  { text: 'All', value: 'All' },
  { text: 'Yes', value: 'True' },
  { text: 'No', value: 'False' }
]
